import _fetch from '@/utils/fetch'

const loadLoginScript = (url: string) => {
  return new Promise<void>(resolve => {
    const script = document.createElement('script')
    script.src = url
    script.async = true
    script.defer = true
    script.onload = () => {
      resolve()
    }
    document.head.appendChild(script)
  })
}
const handleCredentialResponse = async (
  response: any,
  source: string,
  callback: Function,
  loadingCallback?: Function
) => {
  // console.log('Sign-In credential response:', response);
  loadingCallback && loadingCallback()
  const token = response.credential
  if (token) {
    // console.log('ID Token:', token);
    const response = await _fetch('/aigc/api/auth/login/third', {
      method: 'POST',
      body: JSON.stringify({
        accessToken: token,
        source: source
      })
    })
    const res = await response.json()
    if (res.code === 200) {
      callback && callback(res, source)
    }
  } else {
    console.log('Cancel login')
  }
}

export const googleLogin = (callback: Function, loadingCallback?: Function) => {
  loadingCallback && loadingCallback()
  loadLoginScript('https://accounts.google.com/gsi/client').then(() => {
    window.google.accounts.id.initialize({
      client_id: '371886599684-7u937fuhq8vda2fnffg8b0bs2quulims.apps.googleusercontent.com',
      callback: (response: any) => {
        handleCredentialResponse(response, 'google', callback, loadingCallback)
      }
    })
    // window.google.accounts.id.prompt();
    // 监听用户关闭登录提示框的事件
    window.google.accounts.id.prompt((notification: any) => {
      if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
        // 用户关闭了登录提示框
        // console.log('User closed the Google login prompt');
        loadingCallback && loadingCallback()
      }
    })
  })
}

export const googleIframeLogin = (callback: Function) => {
  loadLoginScript('https://accounts.google.com/gsi/client').then(() => {
    window.google.accounts.id.initialize({
      client_id: '371886599684-7u937fuhq8vda2fnffg8b0bs2quulims.apps.googleusercontent.com',
      callback: (response: any) => {
        handleCredentialResponse(response, 'google', callback)
      }
    })
    window.google.accounts.id.renderButton(document.getElementById('google_customBtn'), {
      theme: 'outline',
      text: 'signin_with',
      size: 'large',
      width: document.getElementById('google_customBtn')?.clientWidth,
      logo_alignment: 'left',
      shape: 'circle'
    })
    window.google.accounts.id.prompt()
  })
}
